<!-- Sidepanel Left -->
<aside [ngClass]="navService.getSideNav() ? 'sidepanel' : 'sidepanel sidepanel--collapsed'"
       (clickOutside)="onClickOutSide($event)" style="overflow: hidden;">
  <div class="sidepanel__logo">
    <a  class="app-logo" >
      <!-- <img src="./assets/images/FleCXLogo-Updated.svg" alt="" class="app-logo__img"> -->
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
           viewBox="0 0 93 27" style="enable-background: new 0 0 93 27" xml:space="preserve" class="app-logo__img">
        <style type="text/css" nonce="portal-css">
          .st0 {
            fill: #fff;
          }
        </style>
        @if(navService.getSideNav()){
        <g [ngClass]="navService.getSideNav() ? 'text' : 'text fade-out'">
          <path class="st0" d="M24.6,21V1.7h12v3.1h-8.8v5.4h7.9v3h-7.9V21H24.6z" />
          <path class="st0" d="M41.4,1.3h-3.2V21h3.2V1.3z" />
          <path class="st0"
            d="M55.9,17.2c-0.4,1.3-1.2,2.4-2.3,3.1c-1.1,0.8-2.4,1.1-3.7,1.1c-0.9,0-1.8-0.2-2.7-0.5    c-0.9-0.4-1.6-0.9-2.3-1.6c-0.6-0.7-1.1-1.5-1.4-2.3c-0.3-0.9-0.5-1.8-0.4-2.7c0-0.9,0.1-1.8,0.4-2.6c0.3-0.8,0.8-1.6,1.4-2.2    c0.6-0.7,1.3-1.2,2.1-1.5c0.8-0.4,1.7-0.6,2.6-0.6c4.1,0,6.5,2.7,6.5,6.9c0,0.3,0,0.7-0.1,1h-9.7c0,0.9,0.4,1.8,1.1,2.5    c0.7,0.7,1.6,1,2.5,1c0.7,0.1,1.5-0.1,2.1-0.6c0.6-0.4,1-1,1.3-1.8L55.9,17.2z M52.9,12.9c0-0.4-0.1-0.8-0.3-1.2    c-0.2-0.4-0.4-0.7-0.7-1c-0.3-0.3-0.7-0.5-1.1-0.6C50.4,10,50,9.9,49.6,10c-0.8,0-1.6,0.3-2.2,0.8c-0.6,0.5-1,1.3-1,2.1H52.9z" />
          <path class="st0"
            d="M56.8,11.4c-0.1-1.3,0.2-2.6,0.6-3.9s1.2-2.4,2.1-3.3c0.9-1,2-1.7,3.2-2.2s2.5-0.8,3.9-0.8    c5.4,0,8.1,3.3,8.9,6.5l-3.5,1.1c-0.3-1.2-1-2.2-2-2.9c-1-0.7-2.2-1-3.4-0.9c-0.8,0-1.6,0.2-2.4,0.5c-0.8,0.3-1.4,0.8-2,1.4    c-0.6,0.6-1,1.3-1.3,2.1c-0.3,0.8-0.4,1.6-0.3,2.4c-0.1,0.8,0.1,1.6,0.3,2.4c0.3,0.8,0.7,1.5,1.3,2.1c0.6,0.6,1.2,1.1,2,1.4    c0.8,0.3,1.6,0.5,2.4,0.5c1.2,0.1,2.4-0.3,3.4-1c1-0.7,1.7-1.8,2-2.9l3.5,1.1c-0.5,2-1.7,3.7-3.3,4.9c-1.6,1.2-3.6,1.8-5.6,1.7    c-1.3,0-2.6-0.2-3.9-0.7c-1.2-0.5-2.3-1.2-3.3-2.2c-0.9-0.9-1.7-2.1-2.1-3.3C56.9,14.1,56.7,12.7,56.8,11.4z" />
          <path class="st0"
            d="M85.9,11.4l6.4,9.7h-4.6l-4.2-6.7L79.3,21h-4.4l6.4-9.7l-6.3-9.7h4.6l4.1,6.7l4.2-6.7h4.4L85.9,11.4z" />
          <path class="st0" d="M93,23.9H56.9V26H93V23.9z" />
        </g>
        }
        <g [routerLink]="'/'" class="icon">
          <path class="st0" d="M6.4,10.9L7.9,6H15l-0.6,2.1H9.4l-0.8,2.8" />
          <path class="st0" d="M6.6,17.4l2-6.5h4.9L12.9,13h-2.7l-1.4,4.4" />
          <path class="st0"
                d="M10.4,22.5c-0.9,0-1.7-0.2-2.4-0.6l-5.5-3.2c-0.7-0.4-1.4-1-1.8-1.8C0.2,16.2,0,15.3,0,14.5V8.1    c0-0.9,0.2-1.7,0.7-2.4c0.4-0.7,1-1.4,1.8-1.8L8,0.7C8.7,0.2,9.6,0,10.4,0c0.9,0,1.7,0.2,2.4,0.6l5.5,3.2c0.7,0.4,1.4,1,1.8,1.8    c0.4,0.7,0.7,1.6,0.7,2.4v6.4c0,0.9-0.2,1.7-0.7,2.4c-0.4,0.7-1,1.4-1.8,1.8l-5.5,3.2C12.1,22.3,11.3,22.5,10.4,22.5 M10.4,1.7    c-0.6,0-1.1,0.2-1.6,0.4L3.3,5.3C2.8,5.6,2.4,6,2.1,6.5s-0.4,1-0.4,1.6v6.4c0,0.6,0.2,1.1,0.4,1.6c0.3,0.5,0.7,0.9,1.2,1.2    l5.5,3.2c0.5,0.3,1,0.4,1.6,0.4c0.6,0,1.1-0.1,1.6-0.4l5.5-3.2c0.5-0.3,0.9-0.7,1.2-1.2c0.3-0.5,0.4-1,0.4-1.6V8.1    c0-0.6-0.1-1.1-0.4-1.6C18.4,6,18,5.6,17.5,5.3L12,2.1C11.5,1.9,11,1.7,10.4,1.7" />
        </g>
      </svg>
    </a>
  </div>
  <div class="sidepanel__toggle" [attr.data-interaction]="!navService.getSideNav() ? 'side nav close' : 'side nav open'">
    <a  (click)="navService.setSideNav(!navService.getSideNav())" data-sidenav="toggle"
       class="active-link" [attr.data-interaction]="!navService.getSideNav() ? 'side nav close' : 'side nav open'">
      <div class="hamburger" [ngClass]="!navService.getSideNav() ? 'hamburger--close' : ''" [attr.data-interaction]="!navService.getSideNav() ? 'side nav close' : 'side nav open'">
        <div class="hamburger__stripes" [attr.data-interaction]="!navService.getSideNav() ? 'side nav close' : 'side nav open'"></div>
        <div class="hamburger__stripes" [attr.data-interaction]="!navService.getSideNav() ? 'side nav close' : 'side nav open'"></div>
        <div class="hamburger__stripes" [attr.data-interaction]="!navService.getSideNav() ? 'side nav close' : 'side nav open'"></div>
      </div>
      <div class="toggle-link__content" [attr.data-interaction]="!navService.getSideNav() ? 'side nav close' : 'side nav open'"></div>
    </a>
  </div>
  <nav class="sidepanel__nav">
    <ng-scrollbar style="height: 100%;">
      <!-- <ul class="nav-container"> -->
      <ul class="nav-container --minimal">
        @for (nav of navService.sideNavs; track $index) {
        <li [ngClass]="nav.isBottomLink ? 'bottom-link' : ''">
          @if(nav.show){
          <ng-container>
            <a (click)="handleNavItemClick($event, nav)" data-subnav="toggle"
               [ngClass]="nav.opened ? 'toggle-link toggle-link--opened' : 'toggle-link'" [attr.data-interaction]="nav.name + ' side nav'">
              <i [class]="nav.icon" [attr.data-interaction]="nav.name + ' side nav'"></i>
              <div [attr.data-interaction]="nav.name + ' side nav'" class="collapsed-link-txt">
                <p [attr.data-interaction]="nav.name + ' side nav'">{{ nav.name }}</p>
              </div>
              <div  @fadeIn @fadeOut class="toggle-link__content">
                <p [attr.data-interaction]="nav.name + ' side nav'">{{ nav.name }}</p>
                @if(nav.children && nav.children?.length > 0){
                <i [attr.data-interaction]="!nav.opened ? 'sub nav un-collapse' : 'sub nav collapse'" (click)="toggleNav($event, nav)"
                  [ngClass]="!nav.opened ? 'fa-light fa-angle-right toggle-icon' : 'fa-light fa-angle-down toggle-icon'"></i>
                }
              </div>
              </a>
              @if(nav.children && nav.children?.length > 0 && nav.opened){
              <ul class="dropdown-menu" [ngStyle]="{ display: navService.getSideNav() ? 'block' : 'none' }">
                @for (subNav of nav.children; track $index) {
                <li>
                  @if(subNav.show){
                  <ng-container >
                    <a [attr.data-interaction]="subNav.name + ' side sub nav'" (click)="navService.setSideNav(false)" (click)="handleSubNavNavItemClick($event, subNav)" [routerLink]="subNav.url" routerLinkActive="active">
                      <i [attr.data-interaction]="subNav.name + ' side sub nav'" [class]="subNav.icon"></i>
                      <span [attr.data-interaction]="subNav.name + ' side sub nav'" class="name">{{ subNav.name }}</span>
                      @if (subNav.beta) {
                        <span class="beta">Beta</span>
                      }
                    </a>
                  </ng-container>
                  }
                </li>
                }
              </ul>
              }
          </ng-container>
        }
        </li>
      }
      </ul>
    </ng-scrollbar>
  </nav>
  <!-- overlay with glass effect -->
  <!-- <div (click)="navService.setSideNav(false)"
       [ngClass]="navService.getSideNav() ? 'sidepanel__overlay' : 'sidepanel__overlay slide'" data-overlay="sidepanel">
  </div> -->
</aside>
